import { useCallback } from 'react';

import { LOYALTY_ONBOARDING_MODAL } from '../../../constants';
import { useBraze } from '../../../context/Braze';
import { useLoyaltyPremiumStatus } from '../..';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A hook that logs a Braze custom event for loyalty onboarding purposes based
 * on the user's loyalty membership status.
 *
 * Can be used as an effect (`useEffect`, `useFocusEffect`) or in response to an action.
 */
export const useLogLoyaltyOnboardingModalEvents = () => {
  const { logCustomEvent } = useBraze();

  // ─── Remote Data ─────────────────────────────────────────────────────

  const { hasResolvedPremiumStatus, isPremium } = useLoyaltyPremiumStatus({ requestPolicy: 'cache-only' }); // prettier-ignore

  // ─────────────────────────────────────────────────────────────────────

  return useCallback(() => {
    if (!hasResolvedPremiumStatus) return;

    const event = isPremium ? SHOW_GOAT_MODAL : SHOW_MODAL;

    logCustomEvent(event);
  }, [hasResolvedPremiumStatus, isPremium, logCustomEvent]);
};

// ─────────────────────────────────────────────────────────────────────────────

const { SHOW_MODAL, SHOW_GOAT_MODAL } = LOYALTY_ONBOARDING_MODAL.CUSTOM_EVENTS;
